import { createSelector } from 'reselect'

export const getPreloader = (state) => state.preloader
export const getPreloaderSettings = (state) => state.storyLine.preloader
export const getPreloaded = createSelector([getPreloader], (preloader) => preloader.preloaded)
export const getProgress = createSelector(
  [getPreloader],
  (preloader) => preloader.toPreloadItemsCount - preloader.preloadedItemsCount
)
export const getToPreloadItemsCount = createSelector(
  [getPreloader],
  (preloader) => preloader.toPreloadItemsCount
)
